export * from './airportGeneral';
export * from './airportOpsHrs';
export * from './airportSvcTwy';
export * from './airportRunway';
export * from './airportFrequencies';
export * from './airportProcedures';
export * from './airportContact';
export * from './airportAgents';
export * from './airportRemarks';
export * from './airportMedia';
export * from './countries';
export * from './countryContacts';
export * from './countryImmigration';
export * from './countryPermits';
export * from './routesFixes';
export * from './airways';
export * from './sids';
export * from './starts';
export * from './firBoundaries';
export * from './fir';
export * from './makeAndModel';
export * from './aircraft';
export * from './aircraftDocuments';
export * from './endpoints';

export const yesNo = [
  { itemValue: '', itemLabel: 'Select...' },
  { itemValue: 'PENDING', itemLabel: 'PENDING' },
  { itemValue: 'Y', itemLabel: 'YES' },
  { itemValue: 'N', itemLabel: 'NO' },
];

export const shortYesNo = [
  { itemValue: 'Y', itemLabel: 'YES' },
  { itemValue: 'N', itemLabel: 'NO' },
  { itemValue: 'Y-L', itemLabel: 'Y-L' },
  { itemValue: null, itemLabel: '' },
];

export const airwayAltitude = [
  { itemValue: 'UPPER', itemLabel: 'UPPER' },
  { itemValue: 'LOWER', itemLabel: 'LOWER' },
];

export const airwayAltitudePlus = [
  { itemValue: 'UPPER', itemLabel: 'UPPER' },
  { itemValue: 'LOWER', itemLabel: 'LOWER' },
  { itemValue: 'BOTH', itemLabel: 'BOTH' },
];

export const arrivalOrDeparture = [
  { itemValue: 'ARRIVAL', itemLabel: 'ARRIVAL' },
  { itemValue: 'DEPARTURE', itemLabel: 'DEPARTURE' },
];

export const upDown = [
  { itemValue: '', itemLabel: 'Select...' },
  { itemValue: 'UP', itemLabel: 'UP' },
  { itemValue: 'DOWN', itemLabel: 'DOWN' },
];

export const languages = [
  { itemValue: 'SPANISH', itemLabel: 'SPANISH' },
  { itemValue: 'ENGLISH', itemLabel: 'ENGLISH' },
];

export const genders = [
  { itemValue: 'MALE', itemLabel: 'MALE' },
  { itemValue: 'FEMALE', itemLabel: 'FEMALE' },
  { itemValue: 'OTHER', itemLabel: 'OTHER' },
];

export const daysOfTheWeek = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
];

export const createRange = (total) => {
  let numberArray = [
    { itemValue: 'PENDING', itemLabel: 'PENDING' },
    { itemValue: 'NULL', itemLabel: 'NULL' },
  ];
  for (let i = 1; i <= total; i++) {
    numberArray.push({ itemValue: String(i), itemLabel: String(i) });
  }
  return numberArray;
};

export const colors = [
  { itemValue: 'A-Amber', itemLabel: 'A-Amber' },
  { itemValue: 'B-Blue', itemLabel: 'B-Blue' },
  { itemValue: 'BE-Beige', itemLabel: 'BE-Beige' },
  { itemValue: 'BK-Black', itemLabel: 'BK-Black' },
  { itemValue: 'BR-Brown', itemLabel: 'BR-Brown' },
  { itemValue: 'G-Green', itemLabel: 'G-Green' },
  { itemValue: 'GD-Gold', itemLabel: 'GD-Gold' },
  { itemValue: 'GY-Grey', itemLabel: 'GY-Grey' },
  { itemValue: 'M-Maroon', itemLabel: 'M-Maroon' },
  { itemValue: 'O-Orange', itemLabel: 'O-Orange' },
  { itemValue: 'P-Purple', itemLabel: 'P-Purple' },
  { itemValue: 'PK-Pink', itemLabel: 'PK-Pink' },
  { itemValue: 'R-Red', itemLabel: 'R-Red' },
  { itemValue: 'S-Silver', itemLabel: 'S-Silver' },
  { itemValue: 'TQ-Turquoise', itemLabel: 'TQ-Turquoise' },
  { itemValue: 'T-Tan', itemLabel: 'T-Tan' },
  { itemValue: 'V-Violent', itemLabel: 'V-Violent' },
  { itemValue: 'W-White', itemLabel: 'W-White' },
  { itemValue: 'Y-Yellow', itemLabel: 'Y-Yellow' },
];

export const documentsNames = [
  { itemValue: 'PASSPORT', itemLabel: 'PASSPORT' },
  { itemValue: 'U.S. PERMANENT RES. CARD', itemLabel: 'U.S. PERMANENT RES. CARD' },
  { itemValue: 'U.S. ALIEN REGISTRATION CARD', itemLabel: 'U.S. ALIEN REGISTRATION CARD' },
  { itemValue: 'MILITARY ID CARD', itemLabel: 'MILITARY ID CARD' },
  { itemValue: 'U.S. RE-ENTRY PERMIT TRAVEL DOC.', itemLabel: 'U.S. RE-ENTRY PERMIT TRAVEL DOC.' },
  { itemValue: 'U.S. REFUGEE PERMIT TRAVEL DOC.', itemLabel: 'U.S. REFUGEE PERMIT TRAVEL DOC.' },
  { itemValue: 'U.S. BORDER CROSSING CARD.', itemLabel: 'U.S. BORDER CROSSING CARD.' },
  { itemValue: 'U.S. MERCHANT MARINER DOC.', itemLabel: 'U.S. MERCHANT MARINER DOC.' },
  { itemValue: 'NEXUS CARD.', itemLabel: 'NEXUS CARD.' },
  { itemValue: 'SENTRI CARD.', itemLabel: 'SENTRI CARD.' },
  { itemValue: 'U.S. Visa', itemLabel: 'U.S. Visa' },
  { itemValue: 'NO DOCUMENT PROVIDED*', itemLabel: 'NO DOCUMENT PROVIDED*' },
  { itemValue: 'FACILITATION DOC.', itemLabel: 'FACILITATION DOC.' },
  { itemValue: 'MISCELLANEOUS', itemLabel: 'MISCELLANEOUS' },
];
